<template>
  <PublicLicenseMap v-if="embedded" :city-id="cityId" :selected-license-id="$attrs.selectedLicenseId"
    :only-show-active="$attrs.onlyShowActive" :only-show-pending="$attrs.onlyShowPending" />
  <SpinnerView v-else-if="!checked" />
  <PublicLicenseDirectory v-else-if="publicView" :city-id="cityId" />
  <LicensesComponent v-else v-bind="$attrs" :city-id="cityId" :embedded="embedded" />
</template>

<script>
import { Session } from '@/models/User';
import PublicLicenseDirectory from './PublicLicenseDirectory.vue';
import PublicLicenseMap from './PublicLicenseMap.vue';
import LicensesComponent from './LicensesComponent.vue';
import SpinnerView from './common/SpinnerView.vue';

export default {
  inheritAttrs: false,
  components: {
    PublicLicenseDirectory,
    PublicLicenseMap,
    LicensesComponent,
    SpinnerView
  },
  props: {
    cityId: String,
    embedded: Boolean
  },
  computed: {
    checked() {
      return Session.currentUserChecked.value;
    },

    publicView() {
      const user = Session.currentUser.value;

      return this.embedded || !user || (!user.isAdmin && !user.cities.includes(this.cityId));
    }
  }
};
</script>
